import { useMutation } from '@apollo/client';
import { PATCH_TAG_MUTATION } from '../mutations/PATCH_TAG_MUTATION';

export function usePatchTagMutation() {
    return useMutation( PATCH_TAG_MUTATION );
}
